export function compareString(value1,value2) {
    var areEqual = value1.toUpperCase() === value2.toUpperCase()
    console.log('Return Equal:',areEqual);
    return areEqual;
}